import React, { useEffect } from "react";
import { fetchRevYTDPie } from "../../store/reducers/dashboardSlice/api";
import { revYTDHeaders } from "../../Utils/TableColumnDefs";
import PieChartWithTable from "../PieChartWithTable";
import { useDispatch, useSelector } from "react-redux";
import { useAbortController } from "../../hooks/useAbortController";

const RevenueYTDPie = ({ formOptions }) => {
  const { signal } = useAbortController();
  const { watch, register, setValue } = formOptions;
  const dateSellected = watch("date_range");
  const dispatch = useDispatch();
  const data = useSelector((state) => state.dashboard?.["revYTDPie"]?.data);
  const status = useSelector((state) => state.dashboard?.["revYTDPie"]?.status);
  const lenderId = useSelector((state) => state.account.lenderId);
  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchRevYTDPie({ lenderId, extraParam: dateSellected, signal }));
    }
  }, [dateSellected, dispatch, lenderId, status]);
  const handleClick2 = (data, value) => {
    dispatch(fetchRevYTDPie({ lenderId, extraParam: value, signal }));
    setValue(data, value);
  };
  const title = dateRangeSelect[0].options?.filter(
    (data) => data.value === watch("date_range")
  )[0].label;
  return (
    <PieChartWithTable
      headers={revYTDHeaders}
      title={`Revenue ${title}`}
      pieLabel={"categoryName"}
      pieValue={"amount"}
      formOption={{
        options: dateRangeSelect,
        register,
        watch,
        setValue: (data, value) => handleClick2(data, value),
        status,
        resp: data.resp,
        total: data.total,
      }}
    />
  );
};

export default RevenueYTDPie;
const dateRangeSelect = [
  {
    title: "Date Range",
    field: "date_range",
    type: "select",
    options: [
      { label: "Year to Date", value: "Year to Date" },
      { label: "Last Quarter", value: "Last Quarter" },
      { label: "Last 3 Month", value: "Last 3 Month" },
      { label: "Last 6 Month", value: "Last 6 Month" },
      { label: "Last 12 Month", value: "Last 12 Month" },
      { label: "2025", value: "2025" },
      { label: "2024", value: "2024" },
      { label: "2023", value: "2023" },
      { label: "2022", value: "2022" },
      { label: "2021", value: "2021" },
      { label: "2020", value: "2020" },
      { label: "2019", value: "2019" },
      { label: "2018", value: "2018" },
      { label: "2017", value: "2017" },
      { label: "2016", value: "2016" },
      { label: "2015", value: "2015" },
      { label: "2014", value: "2014" },
      { label: "2013", value: "2013" },
    ],
  },
];
